import React from 'react';
import styles from './settings.module.scss';
import { useNavigate } from 'react-router-dom';
import testIds from '@smart-tv/e2e/shared/variables';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import Button from '@smart-tv/components/button/button';
import useAuthenticate from '@smart-tv/hooks/use-authentication';
import useSuspendStartOverCancel from '@smart-tv/hooks/use-suspend-start-over-cancel';

interface Props {
  onClose: () => void;
}

export const SettingsLogoutDialogButtons: React.FC<Props> = (props: Props) => {
  const { onClose } = props;
  const { ref, focusSelf, focusKey } = useFocusable();
  const { removeAuthentication } = useAuthenticate();
  const navigate = useNavigate();
  const { suspended, setSuspendedCallback } = useSuspendStartOverCancel();

  const handleLogout = React.useCallback(() => {
    const run = () => {
      removeAuthentication();
      navigate('/login');
    };

    suspended ? setSuspendedCallback({ run, type: 'logout' }) : run();
  }, [suspended, setSuspendedCallback, removeAuthentication, navigate]);

  React.useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div 
        ref={ref}
        className={styles['buttons']} 
      >
        <Button 
          className={styles['button']} 
          onClick={handleLogout} 
          data-testid={testIds.settings.logoutDialog.submit}
        >
          Log ud
        </Button>
        <Button
          className={styles['button']}
          onClick={onClose}
          data-testid={testIds.settings.logoutDialog.cancel}
        >
          Annullér
        </Button>
      </div>
    </FocusContext.Provider>
  );
};

export default SettingsLogoutDialogButtons;
